import { addScript } from '../utils/domUtils.js';
import { conf } from './configService.js';

const addGTMScript = () =>
  addScript(
    `https://www.googletagmanager.com/gtm.js?id=${conf.tagManagerContainerID}`
  );

export const googleTagManagerService = {
  init: () =>
    window.addEventListener('CmpReady', addGTMScript, {
      once: true
    })
};
